/**
 * Used to create slightly unique no-cache strings for S3 objects referenced by
 * the PDF generation step. I, C, am unsure why this works. The S3 CORS policy
 * is correct, but for some reason images would fail to load unpredictably from
 * PDF generation. These images would load as <img /> but not as <Image />
 *
 * Apparently, this is because react-pdf fetches the binary data of the file
 * there may be a way to access binary data directly via Amazon API, but the ?no-cache query
 * string is sufficient and quick and does not rely on Amazon API
 *
 * Here's the Issue comment that solved this for me: https://github.com/diegomura/react-pdf/issues/766#issuecomment-630475660
 *
 * For future reference, there is a way to specify image fetch headers in react-pdf: https://github.com/diegomura/react-pdf/pull/485
 */

// Only generate once per app load
const cacheString = Math.random().toString();

export default function formatImageSource(uri: string): any {
  return uri + '?noCache=' + cacheString;
}
